
<script setup>

  import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid';

</script>

<template>

  <div class="grid grid-flow-col items-center gap-6 p-6 text-white bg-red-600">

    <ExclamationTriangleIcon class="w-8" />

    <p class="text-sm">

      <strong class="uppercase">Important:</strong>

      Your work in this activity is not automatically being saved.
      
      To save your work, you must first complete all sections and

      then download your final activity file to your computer or device.

    </p>

  </div>

</template>
